var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',{attrs:{"bottom":50,"right":50,"visibility-height":150}},[_c('img',{attrs:{"src":require("@/assets/img/common/back-top.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }